import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { HomeLogo } from '../../components/icons';
import { useNavigation } from './hooks/useNavigation';
import { Menu, Layout, Button } from '../../components';
import { RightOutlined, MenuOutlined, LeftOutlined } from '@ant-design/icons';
import { CopyrightTermsAndConditions } from './CopyrightTermsAndConditions';
import './sidebar.scss';

const { Sider } = Layout;

const Sidebar = () => {
    const userId = sessionStorage.getItem('loggedInUserId');
    const menuCollapsed = JSON.parse(localStorage.getItem(userId + '_menuCollapsed') || 'false');
    const [collapsed, setCollapsed] = useState(menuCollapsed);

    // Auto-collapse/expand sidebar based on screen width, but allow manual user override
    const isBelowThreshold = useMediaQuery('(max-width: 1199px)');
    useEffect(() => {
        if (isBelowThreshold && !collapsed) {
            setCollapsed(true);
            localStorage.setItem(userId + '_menuCollapsed', true);
        } else if (!isBelowThreshold && collapsed) {
            setCollapsed(false);
            localStorage.setItem(userId + '_menuCollapsed', false);
        }
    }, [isBelowThreshold]);

    const {
        selectedKey,
        openKeys,
        navItems,
        bottomNavItems,
        onClick,
        setOpenKeys,
        handleOpenChange,
        navigateToHome,
        findOpenKeyBySelectedKey,
    } = useNavigation({ collapsed });

    const toggleCollapse = useCallback(() => {
        setCollapsed((prev) => {
            const newState = !prev;
            localStorage.setItem(userId + '_menuCollapsed', newState);
            return newState;
        });
        setOpenKeys([findOpenKeyBySelectedKey]);
    }, [userId, findOpenKeyBySelectedKey]);

    return (
        <Sider collapsible collapsed={collapsed} trigger={null} className={`rm-sider`} collapsedWidth={90} width={294}>
            <div className="sidebar-container">
                <div className="sidebar-top">
                    <div
                        className={`home-logo cursor-pointer ${collapsed ? 'collapsed' : ''}`}
                        onClick={navigateToHome}
                    >
                        <HomeLogo collapsed={collapsed} />
                    </div>
                    <div onClick={toggleCollapse} className={`menu-toggle ${collapsed ? 'collapsed' : ''}`}>
                        {collapsed ? (
                            <Button type="text" icon={<MenuOutlined />} />
                        ) : (
                            <Button type="text" icon={<LeftOutlined />} />
                        )}
                    </div>
                    <Menu
                        className="rm-sidebar-menu scrollbar-hidden"
                        onClick={onClick}
                        mode="inline"
                        items={navItems}
                        triggerSubMenuAction={collapsed ? 'click' : 'hover'}
                        selectedKeys={selectedKey ? [selectedKey] : []}
                        openKeys={openKeys}
                        onOpenChange={handleOpenChange}
                        expandIcon={({ isOpen }) => (
                            <RightOutlined className={`rotate-icon ${isOpen ? 'rotated' : ''}`} />
                        )}
                        key={`menu-${navItems.length}-${selectedKey}`}
                    />
                </div>
                <div className="sidebar-bottom">
                    <div className={`copyright-wrapper ${collapsed ? 'collapsed' : ''}`}>
                        <CopyrightTermsAndConditions />
                    </div>
                </div>
            </div>
        </Sider>
    );
};

export default Sidebar;
